module.exports = __webpack_public_path__ + "static/img/1.ed98606.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/1.jpeg
// module id = SpoW
// module chunks = 3